import { Paper, Stack, Typography } from "@mui/material";
import { linearGradient } from 'helpers/utils';
import { IWorkshopFeature } from "models/EmployeeWorkshopAssessment";
import React from 'react';
import { useTranslation } from "react-i18next";

interface Props {
    title: string;
    slug: 'tests' | 'evaluation' | 'polls' | 'materials' | 'attendance' | 'certificates';
    redirectUrl?: string;
    icon: React.ReactNode;
    color1: string;
    color2: string;
    onSelect: (title: 'tests' | 'evaluation' | 'polls' | 'materials' | 'attendance' | 'certificates') => void;
    isSelected: boolean;
}

// add 12 degree from this color #9c27b0
 

const WorkshopFeatureCard: React.FC<Props> = ({ title, redirectUrl, slug, icon, color1, color2, onSelect, isSelected }) => {
 
 const {t} = useTranslation()

    return (
        <Paper sx={{
            background: linearGradient(color1, color2), borderRadius: 4, p: 2,
            cursor: redirectUrl ? "pointer" : "default",
            width: 130,
            height: 100,
            "&:hover": {
                boxShadow: (theme) => {
                    return `0px 0px 10px ${theme.palette.primary.main}`;
                },
                transform: "scale(1.05)",
                transition: "all 0.3s ease-in-out",
            },
            boxShadow: isSelected ? (theme) => {
                return `0px 0px 10px ${theme.palette.primary.main}`;
            } : 'none',
            transform: isSelected ? "scale(1.05)" : 'none',
            transition: "all 0.3s ease-in-out",
            
        }}
            elevation={4}
            onClick={()=>onSelect(slug)}
        >
            <Stack spacing={1} alignItems={'center'} justifyContent={'center'}>
                {icon}
                <Typography variant={'h6'} color={'white'}>{t(title)}</Typography>                 
            </Stack>
        </Paper>
    );
};

export default WorkshopFeatureCard;